import type { FC } from "react";

import { DiscreteHeaderBanner as UIDiscreteHeaderBanner } from "@jti/ui/components/DiscreteHeaderBanner";

import type { discreteHeaderBannerInputs } from "./DiscreteHeaderBanner.builder";

export type DiscreteHeaderBannerBuilderProps = BuilderComponentProps<typeof discreteHeaderBannerInputs>;

export const DiscreteHeaderBanner: FC<DiscreteHeaderBannerBuilderProps> = ({
  title,
  description,
  backgroundImage,
  linkLabel,
  linkHref,
  theme,
}) => {
  return (
    <UIDiscreteHeaderBanner
      title={title}
      description={description}
      backgroundImage={backgroundImage}
      linkLabel={linkLabel}
      linkHref={linkHref}
      theme={theme}
    />
  );
};
